import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const dsn = import.meta.env.VITE_SENTRY_DSN;
if (dsn && typeof dsn === "string" && dsn.startsWith("http")) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE ?? "development",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserSessionIntegration(),
    ],
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1,
  });
}

createRoot(document.getElementById("root")!).render(<App />);
